import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { PhoneIcon } from '../../../../../../../global/icons/icons';
import DialInSelect from '../dial-in-select';
import { AudioBridgeConfigurationVM, IDropdownOption } from '../audio-bridge-configuration.viewmodel';
import './dial-in-info.scss';

interface IProps {
    vm: AudioBridgeConfigurationVM;
};

const DialInInfo = (props: IProps): JSX.Element => {
    const { vm } = props;

    const {
        connection,
        isCustomParticipantTelephoneNumbers,
        initialTelephoneNumbers,
        countries,
        initialPhone,
        initialCountry,
    } = vm;

    const [phoneNumber, setPhoneNumber] = useState<IDropdownOption>(initialPhone);
    const [phoneNumbers, setPhoneNumbers] = useState<IDropdownOption[]>(initialTelephoneNumbers);
    const [country, setCountry] = useState<IDropdownOption>(initialCountry);

    const selectTelephoneNumber = (value: IDropdownOption): void => {
        setPhoneNumber(value);
    };

    const handleCountryChange = (dropdownOption: IDropdownOption): void => {
        const phoneNumbersByCounty = vm.getPhoneNumbersByCountry(dropdownOption.value) ?? [];
        const phoneNumbersSelectOptions = vm.getPhoneNumberSelectOptions(phoneNumbersByCounty);

        setPhoneNumbers([...phoneNumbersSelectOptions]);
        setCountry(dropdownOption);
        setPhoneNumber(phoneNumbersSelectOptions[0]);
    };

    const hasMultipleOptions = phoneNumbers.length > 1;

    return (
        <div className='dial-in-info-wrapper'>
            <div className='dial-in-info__phone-number'>
                <div className='dial-in-info__phone-icon'>
                    <PhoneIcon />
                </div>
                {isCustomParticipantTelephoneNumbers || hasMultipleOptions
                    ?
                    <DialInSelect
                        selectedOption={phoneNumber}
                        onChange={selectTelephoneNumber}
                        options={phoneNumbers}
                    />
                    : <span className='dial-in-info__one-option'>{phoneNumber.value}</span>
                }
            </div>

            {!connection.autoSyncEnabled &&
                <>
                    {connection.conferenceId &&
                        <div className='dial-in-info__field'>
                            <label className='dial-in-info__label'>
                                <FormattedMessage
                                    id='oe.uniqueJoinMethodDetailsLabels.conferenceId'
                                    description='Conference ID'
                                    defaultMessage='Conference ID'
                                />
                            </label>
                            <span className='dial-in-info__value'>{connection.conferenceId}</span>
                        </div>
                    }
                    {connection.participantId &&
                        <div className='dial-in-info__field'>
                            <label className='dial-in-info__label'>
                                <FormattedMessage
                                    id='oe.uniqueJoinMethodDetailsLabels.participantId'
                                    description='Participant ID'
                                    defaultMessage='Participant ID'
                                />
                            </label>
                            <span className='dial-in-info__value'>{connection.participantId}</span>
                        </div>
                    }
                    {connection.connectionPassword &&
                        <div className='dial-in-info__field'>
                            <label className='dial-in-info__label'>
                                <FormattedMessage
                                    id='oe.connectionsDetailsLabels.Passcode'
                                    description='Passcode Label'
                                    defaultMessage='Passcode'
                                />
                            </label>
                            <span className='dial-in-info__value'>{connection.connectionPassword}</span>
                        </div>
                    }

                </>}

            {connection.autoSyncEnabled &&
                <div className='dial-in-info__field'>
                    <label className='dial-in-info__label'>
                        <FormattedMessage
                            id='oe.uniqueJoinMethodDetailsLabels.participantId'
                            description='Participant ID'
                            defaultMessage='Participant ID'
                        />
                    </label>
                    <span className='dial-in-info__value'>000-000-000</span>
                </div>
            }

            {!isCustomParticipantTelephoneNumbers && countries &&
                <div className='dial-in-info__field'>
                    <label className='dial-in-info__label'>Country</label>
                    <DialInSelect
                        selectedOption={country}
                        onChange={handleCountryChange}
                        options={countries}
                    />
                </div>
            }
        </div>
    );
};

export { DialInInfo };
